import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';


const BasicCard = ({sr, handleOpen}) => {

  let borderColor = 'primary.card_ss_closed';

  if(sr.status !== null && sr.status !== undefined){
    borderColor = sr.status.includes('Aguardando')? 'primary.card_ss_open': 'primary.card_ss_distributed';

  };

  return (

    <Card sx={{ mb: 1, minHeight: 180, boxShadow: 0.1, borderLeft: 4, borderColor: borderColor }}>
      <CardContent>
        <Typography variant='h6' component='div' sx={{borderBottom: 1, borderColor: 'text.secondary', color: 'primary.text'}}>
          {sr.number}
        </Typography>

        {sr.status === null || sr.status === undefined? null : (
          <Typography color={sr.status.includes('Aguardando')? 'primary.card_ss_open': 'primary.card_ss_distributed'} sx={{ mt: 1, mb: 1 }}>
            {sr.status}
          </Typography>
        )}

        {sr.performer === null || sr.performer === undefined? null : (
          <Typography color='text.secondary'>
            {`Executante: ${sr.performer}`}
          </Typography>
        )}

        <Typography color='text.secondary'>
          {`Dt. Abertura: ${sr.openingDate}`}
        </Typography>
        <Typography color='text.secondary'>
          {`Bem: ${sr.asset}`}
        </Typography>
        <Typography color='text.secondary'>
          {`Tipo de serviço: ${sr.serviceType}`}
        </Typography>
      </CardContent>
      <CardActions sx={{display: 'flex', width: '100%', justifyContent: 'flex-end'}}>
        <Button size='small' onClick={()=> handleOpen(sr)}>Abrir</Button>
      </CardActions>
    </Card>

  );
};

export default BasicCard;